// KONE-23396: a single batch is capped at User × SKU = 100 combinations (per ticket).
export const BATCH_CAP = 100;
export const SEARCH_PAGE_SIZE = 20;

export type SelectedUser = { userId: string; organizationId: string; email: string };
export type UserOption = SelectedUser & { organizationName?: string };
export type SelectedSku = { skuId: string; code: string; title: string };
export type ReviewRow = SelectedUser & SelectedSku;

export const pairKey = (userId: string, skuId: string) => `${userId}|${skuId}`;
